//Library modul
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

//Personal Component

//Redux function
import { getUserPaymentList } from "../../App/actions/paymentActions";

//Picture Asset

//General Function
import isEmpty from "../../App/validation/is-empty";
import dict from "../../Data/dict.json";
import formatDate from "../../App/validation/format-date";
import { convert_to_currency_with_unit } from "../../App/validation/convert_to_currency_with_unit";
import { payment_type_to_name_of_license } from "../../App/validation/license_helper";

class HISTORY_PAYEMNT extends Component {
  state = {};

  componentDidMount() {
    this.props.getUserPaymentList();
  }

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const {
      payment_list,
      loadingList,
      // license_list
    } = this.props.payment;
    const payment_list_filtered = payment_list.filter(
      (e) =>
        [
          "license_0",
          "license_1",
          "license_2",
          "license_3",
          "form",
          "data_exchange",
          "personal",
          "team",
          "enterprise",
        ].includes(e.payment_type) &&
        ![
          "specialist_wait_transfer",
          "specialist_wait_transfer",
          "specialist_paid_off",
          "data_exchange",
          "admin_wait_transfer",
          "admin_paid_off",
          "admin_income",
          "ppn",
        ].includes(e.status)
    );
    let content;
    if (loadingList && isEmpty(payment_list_filtered)) {
      content = <main>Memuat data</main>;
    } else {
      content = (
        <main style={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
          <div>
            {payment_list.map(
              ({
                _id,
                payment_type,
                price,
                status,
                date_in,
                date_user_action,
                payment_methode,
                multiple_month,
                currency,
                amount,
                is_sandbox,
              }) => {
                const date = date_user_action ? date_user_action : date_in;
                let status_text;
                let action_text;
                let backgroundColor;
                switch (status) {
                  case "wait_purchase":
                    status_text = dict?.["Waiting for payment"]?.[language];
                    action_text = dict?.["Confirm"]?.[language];
                    backgroundColor = "#8fcc1b";
                    break;
                  case "user_cancel":
                    status_text = dict?.["Payment canceled by you"]?.[language];
                    action_text = dict?.["View details"]?.[language];
                    backgroundColor = "#cecece";
                    break;
                  case "user_purchase":
                    status_text = (
                      <div>
                        {dict?.["Waiting for admin confirmation."]?.[language]}
                        <br />
                        {
                          dict?.[
                          "While our team checks the payment, you can already use the GEO MAPID license."
                          ]?.[language]
                        }
                      </div>
                    );
                    action_text = dict?.["View details"]?.[language];
                    backgroundColor = "#cecece";
                    break;
                  case "success":
                    status_text = dict?.["Payment successful"]?.[language];
                    action_text = dict?.["View details"]?.[language];
                    backgroundColor = "#cecece";
                    break;
                  case "rejected":
                    status_text = dict?.["Payment not found"]?.[language];
                    action_text = dict?.["View details"]?.[language];
                    backgroundColor = "#cecece";
                    break;
                  default:
                    status_text = dict?.["Waiting for payment"]?.[language];
                    action_text = dict?.["View details"]?.[language];
                    backgroundColor = "#cecece";
                    break;
                }
                let payment_type_text = payment_type_to_name_of_license(payment_type);
                if (!payment_type) payment_type_text = dict?.["Other payments"]?.[language]

                const converted_price = convert_to_currency_with_unit({
                  currency,
                  value: price || amount,
                });
                return (
                  <main
                    key={_id}
                    className="container_standard"
                    id="white"
                    style={{
                      position: "relative",
                      padding: "15px",
                      minHeight: "150px",
                      width: "70vw",
                      maxWidth: "800px",
                      marginBottom: "30px",
                    }}
                  >
                    {is_sandbox && (
                      <section
                        style={{
                          margin: "0 0 5px 0",
                          padding: "5px 0 5px 0",
                          backgroundColor: "orange",
                          display: "flex",
                          justifyContent: "center",
                          borderTopLeftRadius: "5px",
                          borderTopRightRadius: "5px",
                        }}
                      >
                        Sandbox mode
                      </section>
                    )}
                    <section
                      className="two_container_equal"
                      style={{
                        fontSize: "13px",
                      }}
                    >
                      <div>
                        {formatDate(date)}
                        <p className="text_bold">{payment_type_text}</p>
                        <p className="text_small">
                          {dict?.["Active period"]?.[language]} {multiple_month}{" "}
                          {dict?.["month"]?.[language]}
                        </p>
                        <p className="text_medium" style={{ color: "#0ca5ebff" }}>
                          {converted_price}
                        </p>
                        <p>{payment_methode}</p>
                      </div>
                      <div>
                        <p className="text_inferior">Status</p>
                        <p className="text_inferior">{status_text}</p>
                      </div>
                    </section>
                    <section
                      style={{
                        position: "absolute",
                        bottom: "0px",
                      }}
                    >
                      <Link
                        to={`/payment/${_id}`}
                        className="button_pill_normal"
                        style={{
                          color: "#ffffff",
                          backgroundColor: backgroundColor,
                          marginBottom: "10px",
                          fontSize: "11px",
                        }}
                      >
                        {action_text}
                      </Link>
                    </section>
                  </main>
                );
              }
            )}
          </div>
        </main>
      );
    }
    return (
      <main>
        {content}
        <Helmet>
          <title>{dict?.["Payment History"]?.[language]}</title>
          <meta
            name="description"
            content={dict?.["Payment History"]?.[language]}
          />
        </Helmet>
      </main>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
});
export default connect(mapStateToProps, { getUserPaymentList })(HISTORY_PAYEMNT);
